const invertedMessages = {
  'User selection required': 'certs.userlistdropdown.required',
  'Please select the correct option from the user list.':
    'certs.userlistdropdown.selectFromList',
};

export default invertedMessages;
